export default "__VITE_ASSET__DLdvfN0l__"